"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var helpers_1 = require("../helpers");
var icons_1 = require("./icons");
var StackView_1 = require("../StackView");
var View_1 = require("../View");
var Text_1 = require("../Text");
var zIndexManager_1 = require("../helpers/zIndexManager");
var SIDE_PANEL_ACTIONS_VIEW;
(function (SIDE_PANEL_ACTIONS_VIEW) {
    SIDE_PANEL_ACTIONS_VIEW[SIDE_PANEL_ACTIONS_VIEW["normal"] = 0] = "normal";
    SIDE_PANEL_ACTIONS_VIEW[SIDE_PANEL_ACTIONS_VIEW["bottom"] = 1] = "bottom";
})(SIDE_PANEL_ACTIONS_VIEW = exports.SIDE_PANEL_ACTIONS_VIEW || (exports.SIDE_PANEL_ACTIONS_VIEW = {}));
var Wrapper = styled_components_1.default(StackView_1.StackView)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-color: ", ";\n    box-shadow: -2px 2px 5px 0 rgba(0, 0, 0, 0.25);\n    overflow: hidden;\n    width: 100%;\n    height: 100%;\n    align-self: stretch;\n    flex-grow: 1;\n"], ["\n    background-color: ", ";\n    box-shadow: -2px 2px 5px 0 rgba(0, 0, 0, 0.25);\n    overflow: hidden;\n    width: 100%;\n    height: 100%;\n    align-self: stretch;\n    flex-grow: 1;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorBackgroundBlank;
});
var StyledCloseIcon = styled_components_1.default(icons_1.CloseIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    min-width: 12px;\n    min-height: 12px;\n"], ["\n    min-width: 12px;\n    min-height: 12px;\n"])));
var Close = styled_components_1.default.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    top: 0;\n    right: 0;\n    width: ", ";\n    height: ", ";\n    border: 0;\n    outline: 0;\n    margin: 0;\n    cursor: pointer;\n    background-color: transparent;\n    z-index: 2;\n\n    &:hover,\n    &:focus {\n        background-color: ", ";\n    }\n\n    &:active {\n        background-color: ", ";\n    }\n"], ["\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    top: 0;\n    right: 0;\n    width: ", ";\n    height: ", ";\n    border: 0;\n    outline: 0;\n    margin: 0;\n    cursor: pointer;\n    background-color: transparent;\n    z-index: 2;\n\n    &:hover,\n    &:focus {\n        background-color: ", ";\n    }\n\n    &:active {\n        background-color: ", ";\n    }\n"])), helpers_1.SIZE_L, helpers_1.SIZE_L, function (_a) {
    var theme = _a.theme;
    return theme.colorHighlightLight;
}, function (_a) {
    var theme = _a.theme;
    return theme.colorHighlightDark;
});
var Title = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n    color: ", ";\n"], ["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n    color: ", ";\n"])), helpers_1.BASE_FONT_FAMILY, helpers_1.FONT_SIZE_L, helpers_1.FONT_LINE_HEIGHT_L, helpers_1.BASE_FONT_BOLD_WEIGHT, function (_a) {
    var theme = _a.theme;
    return theme.colorTextMain;
});
var Content = styled_components_1.default(StackView_1.StackView)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    overflow-y: auto;\n    overflow-x: hidden;\n"], ["\n    overflow-y: auto;\n    overflow-x: hidden;\n"])));
exports.SidePanel = helpers_1.createUIElement('SidePanel', function (_a, ref) {
    var className = _a.className, title = _a.title, description = _a.description, _b = _a.onRequestClose, onRequestClose = _b === void 0 ? function () { } : _b, children = _a.children, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "title", "description", "onRequestClose", "children", "onKeyPress", "style"]);
    var rootRef = react_1.useRef(null);
    var mainRef = ref || rootRef;
    zIndexManager_1.useZIndexManager({
        onKeyPress: function (e) {
            if (e.keyCode === helpers_1.KeyCode.Escape) {
                onRequestClose === null || onRequestClose === void 0 ? void 0 : onRequestClose();
            }
            onKeyPress === null || onKeyPress === void 0 ? void 0 : onKeyPress(e);
        }
    });
    react_1.useEffect(function () {
        var _a;
        (_a = mainRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    return (react_1.default.createElement(Wrapper, __assign({}, rest, { testId: rest['data-selector-id'] || 'side-panel', className: "vm-SidePanel " + className, root: true, spaceAll: View_1.INDENT.m, direction: StackView_1.STACK_DIRECTION.column, spaceFill: View_1.SPACE_FILL.all, distribution: StackView_1.STACK_DISTRIBUTION.lastFill, tabIndex: -1, ref: mainRef, style: style }),
        react_1.default.createElement(StackView_1.StackView, { root: true, spaceBottom: View_1.INDENT.l, direction: StackView_1.STACK_DIRECTION.column },
            (title || description) && (react_1.default.createElement(StackView_1.StackView, { gap: StackView_1.STACK_GAP.s, direction: StackView_1.STACK_DIRECTION.column, spaceRight: View_1.INDENT.l },
                title && react_1.default.createElement(Title, null, title),
                description && react_1.default.createElement(Text_1.Text, null, description))),
            react_1.default.createElement(Close, { "data-selector-id": "side-panel-close", onClick: onRequestClose },
                react_1.default.createElement(StyledCloseIcon, null))),
        react_1.default.createElement(Content, { "data-selector-id": "side-panel-content", direction: StackView_1.STACK_DIRECTION.column, align: StackView_1.STACK_ALIGN.fill }, children)));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=SidePanel.js.map